module.exports = __webpack_public_path__ + "static/img/inbody.9ec2414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/inbody.png
// module id = PttI
// module chunks = 1